import { FieldContextProps, fieldRendererContext } from "."

export const FieldRendererProvider = (props: FieldContextProps & { children: React.ReactNode }) => {
    return <fieldRendererContext.Provider value={props}>{props.children}</fieldRendererContext.Provider>
}
